import { getWeekTypeConfig, type WeekType } from "@/types/weekTypes";
import { Badge } from "@/components/ui/badge";

interface Props {
  type: WeekType;
  isException?: boolean;
  className?: string;
}

export default function WeekTypeBadge({ type, isException, className = "" }: Props) {
  const config = getWeekTypeConfig(type);
  return (
    <Badge className={`${config.badgeColor} border-none gap-1 text-xs font-medium ${className}`}>
      {config.icon} {config.label}
      {isException && <span className="text-destructive ml-1">⚠️</span>}
    </Badge>
  );
}
